import { FC } from "react"
import { LoanOfficer } from "../../../../types"
import { capitalize, CRM_TYPES } from "../../../utils"
import Form from "../../form"

interface Props {
  title: string
  values: LoanOfficer
  setFormField: (name: string, value: string) => void
}

const CRM_TYPE_OPTIONS = CRM_TYPES.map(ct => ({
  id: ct,
  name: ct
    .split("_")
    .map(str => capitalize(str))
    .join(" ")
}))

const IntegrationsSection: FC<Props> = ({ title, values, setFormField }) => (
  <div className="px-6">
    <h4 className="text-xl font-bold text-primary-alt-400 ">{title}</h4>

    <div className="grid gap-y-6 gap-x-8 grid-cols-12 pt-8">
      <div className="col-span-12">
        <Form.Input label="Search LO & Connect pricing engine" name="n/a" />
      </div>
      <div className="col-span-12">
        <Form.Select
          label="CRM type"
          selected={values?.crm_type}
          data={CRM_TYPE_OPTIONS}
          IDkey="id"
          setSelected={val => setFormField("crm_type", val)}
          name="crm_type"
        />
      </div>
      <div className="col-span-12">
        <Form.Input label="Unique CRM ID" name="crm_id" />
      </div>
    </div>
  </div>
)

export default IntegrationsSection
